export default "__VITE_ASSET__4g44Q5XN__"